import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  get,
  sumBy,
  find,
  some,
  findIndex,
  isEmpty,
  filter,
} from 'lodash'
import { connect } from 'react-redux'
import { Waypoint } from 'react-waypoint'

import { getCurrentMenuItemsFilteredByCategory } from '../../selectors/items'
import { getCurrentStand, getCurrentMenu } from '../../selectors/menus'
import {
  getCartItems,
  alcoholItemCountSelector,
  getCartLineItems,
} from '../../selectors/cart'
import { addToCartOrIncrement, removeFromCart } from '../../actions/cart';
import { toggleAppState } from '../../actions/appState'
import Item from './Item'

export class CategoryItems extends Component {
  static propTypes = {
    cartLineItems: PropTypes.array.isRequired,
    category: PropTypes.object,
    items: PropTypes.array.isRequired,
    cart: PropTypes.array.isRequired,
    removeFromCart: PropTypes.func.isRequired,
    refProp: PropTypes.func.isRequired,
    isAgeConfirmed: PropTypes.bool.isRequired,
    isAlcoholWarningConfirmed: PropTypes.bool.isRequired,
    toggleAppState: PropTypes.func.isRequired,
    alcoholItemCount: PropTypes.number.isRequired,
    alcoholLimit: PropTypes.number.isRequired,
    alcoholLimitMessage: PropTypes.string.isRequired,
    scrollableAncestorRef: PropTypes.object.isRequired,
    onViewportItemEnter: PropTypes.func,
    setItemsSummary: PropTypes.func,
  }

  handleAddToCart = item => {
    this.props.setItemsSummary([])
    const { addToCartOrIncrement, toggleSidebar, cartLineItems } = this.props
    const cartItemsMatchingItemId = filter(cartLineItems, ['itemId', item.id])
    const totalItemQuantity = sumBy(cartItemsMatchingItemId, 'quantity')
    const isMaxAmountReached = totalItemQuantity >= (get(item, 'orderMaxAmount') || Infinity)
    addToCartOrIncrement({ itemId: item.uuid })
    if (!isEmpty(item.modifierGroups) && !isMaxAmountReached) {
      toggleSidebar(true)
    }
  }

  handleRemoveFromCart = item => {
    const { removeFromCart } = this.props
    const index = findIndex(this.props.cartLineItems, cartItem => cartItem.itemId === item.id)
    removeFromCart({ index })
  }

  render() {
    const {
      items,
      cart,
      category,
      isAgeConfirmed,
      isAlcoholWarningConfirmed,
      alcoholItemCount,
      alcoholLimit,
      alcoholLimitMessage,
      toggleAppState,
      scrollableAncestorRef,
      onViewportItemEnter,
      cartLineItems,
    } = this.props


    return (
      <div className="categories__group" ref={this.props.refProp}>
        <div className="categories__name">{category.name}</div>
        <div className="categories__items">
          {items.map(item => (
            <Waypoint
              fireOnRapidScroll={false}
              key={item.id}
              onEnter={() => onViewportItemEnter(item)}
              scrollableAncestor={scrollableAncestorRef.current}
            >
              <Item
                addedToCart={some(find(cart, cartItem => cartItem.id === item.id))}
                addToCart={this.handleAddToCart}
                alcoholItemCount={alcoholItemCount}
                alcoholLimit={alcoholLimit}
                alcoholLimitMessage={alcoholLimitMessage}
                cartLineItems={cartLineItems}
                confirmAge={() => toggleAppState({ isAgeConfirmed: true })}
                confirmAlcoholWarning={() => toggleAppState({ isAlcoholWarningConfirmed: true })}
                isAgeConfirmed={isAgeConfirmed}
                isAlcoholWarningConfirmed={isAlcoholWarningConfirmed}
                item={item}
                key={item.id}
                removeFromCart={this.handleRemoveFromCart}
              />
            </Waypoint>
          ))}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  items: getCurrentMenuItemsFilteredByCategory(state, get(ownProps, 'category.name', '')),
  cart: getCartItems(state),
  isAgeConfirmed: state.appState.isAgeConfirmed,
  isAlcoholWarningConfirmed: state.appState.isAlcoholWarningConfirmed,
  alcoholLimitMessage: getCurrentStand(state).alcoholLimitMessage,
  alcoholLimit: getCurrentMenu(state).alcoholLimit,
  alcoholItemCount: alcoholItemCountSelector(state),
  cartLineItems: getCartLineItems(state),
})

const mapDispatchToProps = {
  addToCartOrIncrement,
  removeFromCart,
  toggleAppState,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CategoryItems)
